import React from 'react'
import moment from "moment";
import {checkPermission} from "../../../../../utils/common";
import Pagination from "../../../../../components/Pagination";
import TableHeader from "../../../../../components/TableHeader";
import ModalCreateSchoolYear from './modalCreateSchoolYear'
import ModalEditSchoolYear from './modalEditSchoolYear'
import ModalDeleteSchoolYear from './modalDeleteSchoolYear'
import YearController from "../../../../../services/data-declaration/year-controller";
import {toast} from "react-toastify";

class SchoolTimeManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: "created_at desc",
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showModalCreate: false,
            showModalEdit: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'year',
                    name: 'Năm học',
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'start_ky_1',
                    name: "Ngày bắt đầu \n học kỳ I",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'end_ky_1',
                    name: "Ngày kết thúc  học kỳ I",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'start_ky_2',
                    name: "Ngày bắt đầu  học kỳ II",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'end_ky_2',
                    name: "Ngày kết thúc  học kỳ II",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
        this.setState({showLoading: true}, () => {
            this.getListYears()
        });
    }

    onSearch = () => {
        this.setState({showLoading: true}, () => {
            this.getListYears()
        })
    };
    getListYears = () => {
        let {pageNumber, pageSize, sort, descending, categoryType} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sort: sort,
        };
        YearController.getListYear(payload, res => {
            if (res.success) {
                this.setState({
                    listData: res.data.content,
                    totalItem: res.data.totalElements,
                    totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                    showLoading: false
                });
                localStorage.setItem("ListYear", JSON.stringify(res.data.content))
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };

    handleChangePage = (page) => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.searchListService()
            }
        );
    };

    renderStatus = (statusType, startDate, endDate) => {
        let currentDate = new Date();
        startDate   = moment(startDate).format("DD-MM-YYYY")
        endDate     = moment(endDate).format("DD-MM-YYYY")
        currentDate = moment(currentDate).format("DD-MM-YYYY")
        switch (statusType) {
            case "PENDING":
                return <h6><span className="badge badge-info">Đang duyệt</span></h6>;
            case "ACTIVE":
                if (startDate <= currentDate && currentDate <= endDate)
                    return <h6><span className="badge badge-success">Đang hoạt động</span></h6>;
                else if (currentDate < startDate) {
                    return <h6><span className="badge badge-info">Đang chờ</span></h6>;
                }else {
                    return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
                }
            case "DISABLE":
                return <h6><span className="badge badge-dark">Đã khóa</span></h6>;
            case "EXPIRED":
                return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
            case "DELETEs":
                return <h6><span className="badge badge-danger">Đã xóa</span></h6>;
            default:
                return '';
        }
    };

    render() {
        let {pageNumber, pageSize, accountBalance} = this.state;
        return (
            <div>
                <div className="row">
                    <div className="mb-4 col-md-12 tab-content">
                        {this.state.showLoading &&
                        <div className="content-loading col-12 ml-3 align-items-center"
                             style={{display: 'block'}}>
                            <div className="spinner-grow text-info"/>
                        </div>
                        }
                        <div className="col-12">
                            <div className='mb-4'>
                                <div className="kt-form kt-form--fit">
                                    <div className="row">
                                        <div className='col-xs-12 col-sm-12 col-md-12 text-left pl-0 mt-3'>
                                            {checkPermission("YEAR_ADD") &&
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                title='Thêm mới'
                                                style={{cursor: 'pointer'}}
                                                onClick={() => {
                                                    this.setState({itemSelected: -1, showModalCreate: true})
                                                }}
                                            >
                                                Thêm mới
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-wrapper">
                                <table className="table table-striped table-data table-bordered">
                                    <thead>
                                    <TableHeader header={this.state.header} clickSort={(data) => {
                                        let a = '';
                                        if (data.sortAsc == null) {
                                            a = ''
                                        } else {
                                            a = `id_sort=${data.sortAsc ? 'asc' : 'desc'}`;
                                        }
                                        this.setState({
                                            sort: a
                                        }, () => this.searchListService())
                                    }}/>
                                    </thead>
                                    {!this.state.listData || this.state.listData.length == 0
                                        ? <tbody>
                                        <tr>
                                            <td colSpan={12}>
                                                <div className='text-center'>Không có dữ liệu</div>
                                            </td>
                                        </tr>
                                        </tbody>
                                        : <tbody>
                                        {this.state.listData.map((row, index) => (
                                            <tr key={row.id} style={{height: 50}}>
                                                <td style={{textAlign: 'center'}}>{pageNumber * pageSize + index + 1}</td>
                                                <td style={{textAlign: 'center',}}>
                                                    {row.year}-{parseInt(row.year)+1}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.startSemesterOne ? moment(row.startSemesterOne).format("DD-MM-YYYY") : ''}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.endSemesterOne ? moment(row.endSemesterOne).format("DD-MM-YYYY") : ''}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.startSemesterTwo ? moment(row.startSemesterTwo).format("DD-MM-YYYY") : ''}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.endSemesterTwo ? moment(row.endSemesterTwo).format("DD-MM-YYYY") : ''}
                                                </td>
                                                <td className='p-1' style={{textAlign: 'center'}}>

                                                    {(checkPermission("YEAR_EDIT") || checkPermission("YEAR_DETAIL")) &&
                                                    <button className="btn btn-action p-2"
                                                            title='Sửa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalEdit: true})
                                                            }}
                                                    >
                                                        <i className="ti-pencil-alt"/>
                                                    </button>
                                                    }
                                                    {checkPermission("YEAR_DELETE") &&
                                                    <button className="btn btn-action p-2"
                                                            title='Xóa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                            }}
                                                    >
                                                        <i className="ti-trash"/>
                                                    </button>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>}
                                </table>
                            </div>
                            <div className="pagination-right">
                                <Pagination
                                    activePage={this.state.pageNumber}
                                    itemsCountPerPage={this.state.pageSize}
                                    totalItemsCount={this.state.totalItem}
                                    changeHandler={(page) => this.handleChangePage(page)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ModalDeleteSchoolYear
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />

                <ModalCreateSchoolYear
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />

                <ModalEditSchoolYear
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        )
    }

}

export default SchoolTimeManagement
